export const ATTENDANCE_LOG_TYPES = {
    INIT: { value: "INIT", text: "출근" },
    DONE: { value: "DONE", text: "퇴근" },
};
